import styled from 'styled-components'

const Container = styled.div`
     max-width: 1411px;
    padding: 0 85px;
    width: 100%;
    margin: 0 auto;
    @media screen and (max-width: 1250px) {
        padding: 0 15px;
    }
`;

const Heading = styled.h3`
    font-size: 24px;
    font-family: "latobold";
    padding: 15px 0;
`
export {Container, Heading};